import React, { useEffect, useState } from 'react';
import ProposalList from '../../../components/proposal'
const Declaration = (props) => {

    const [initialdata, setData] = useState([]);
    const proposeData =
    {
        "RL": "Referred Lead",
        "SELF": "Self",
        "IF": "Immediate Family*",
        "FA": "Friend/Acquaintance",
        "EC": "Existing Client",
        "MOAOWN": "MOA's /MOM's / FA's own Policy",
        "SMOWN": "SM's / SP's / Broker's own Policy",
        "MOAIMMF": "MOA's /MOM's / FA's Immediate Family*",
        "SMIMMF": "SM's / SP's / Broker's Immediate Family*",
        "MOAREL": "MOA's /MOM's / FA's relative",
        "SMREL": "SM's / SP's / Broker's relative",
        "DM": "Direct Marketing",
        "CC": "Cold Call",
        "CPI": "Contacted by Proposer for Insurance",
        "OTHERS": "Others",
        "DD": "DD - S2S",
        "AGENCY": "Agency - S2S",
        "WINBACK": "Winback - S2S"
    }

    useEffect(() => {
        // console.log("==============>", props.proposalData)
        if (props.proposalData && props.proposalData) {
            const { agentQuestionDetail } = props.proposalData;
            // console.log("=========>", agentQuestionDetail)
            let newdata = [];
            for (let data in agentQuestionDetail) {
                agentQuestionDetail[data].map(item => {
                    newdata.push({
                        name: item.question,
                        value: item.question === "Proposer is" ? proposeData[item.answer] : item.answer + ` ${item.details}`,
                        show: item.answer ? true : false
                    });
                    return newdata;
                });
            }
            setData(newdata)
            // let data;
            // data = seedData.map((item) => {
            //     console.log(item.key, basicDetails.coverageDetails[item.key])
            //     if (basicDetails.coverageDetails[item.key]) {
            //         item.value = basicDetails.coverageDetails[item.key];
            //     } else if (props.proposalData.mcustomerResponse[item.key]) {
            //         item.value = props.proposalData.mcustomerResponse[item.key]
            //     }
            //     return item;
            // })
            // setData(data)
        }
    }, [props]);
    return (
        <div className="main_container">
            <ProposalList initialdata={initialdata} />
        </div>
    )
}

export default Declaration;